import React from 'react';

import Image from '../assets/pfp.jpg';

import {FaGithub, FaYoutube, } from 'react-icons/fa';

import {TypeAnimation} from 'react-type-animation' 

import {motion} from 'framer-motion' 

import {fadeIn} from '../variants' 
import { Link } from 'react-scroll';

const Banner = () => {
  return( 
  <section className='min-h-[85vh] lg:min-h-[78vh] flex items-center' id='home'>
    <div className="container mx-auto">
      <div className='flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12'>
        {/* text */}
        <div className='flex-1 text-center font-secondary lg:text-left text-white'>
          <motion.h1 variants={fadeIn('up', 0.3)} initial="hidden" whileInView={'show'} viewport={{once: false, amount: 0.7}} className='text-[55px] font-bold leading-[0.8] lg:text-[110px]'>
            JEREMIAH <span>Hetzel</span>
            </motion.h1>
            <motion.div variants={fadeIn('up', 0.3)} initial="hidden" whileInView={'show'} viewport={{once: false, amount: 0.7}} className='mb-6 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]'>
              <span className=' mr-4'>I am a</span>
              <TypeAnimation sequence={[
                'Developer',
                2000,
                'Youtuber',
                2000,
                'Designer',
                2000
              ]} 
              speed={50} 
              className='text-accent'
              wrapper='span'
              repeat={Infinity}
              />
            </motion.div>
            <motion.p variants={fadeIn('up', 0.7)} initial="hidden" whileInView={'show'} viewport={{once: false, amount: 0.7}} className='mb-8 max-w-lg mx-auto lg:mx-0'>
              Hi , My name is Jeremiah .
              I design and develop unique Websites 
              which attract and compel lots of
              interested clients to hire me . 
            </motion.p>
            <motion.div  variants={fadeIn('up', 0.9)} initial="hidden" whileInView={'show'} viewport={{once: false, amount: 0.7}}className='flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0 '>
              <Link to='contact' activeClass='active' smooth={true}  spy={true}>
              <button className='btn btn-lg'>Contact me</button>
              </Link>
              <a href="#" className='text-gradient btn-link'>My Portfolio</a>
            </motion.div>
            {/* social */}
            <motion.div variants={fadeIn('up', 1.1)} initial="hidden" whileInView={'show'} viewport={{once: false, amount: 0.7}} className='flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0'>
              <a href='https://www.youtube.com/channel/UCKPLwe5U2OUARK7v5-1ko-w'>
                  <FaYoutube />
              </a>
              <a href='https://github.com/melonmusk2'>
                  <FaGithub />
              </a>
            </motion.div>
        </div>
          {/* image */}
        <motion.div variants={fadeIn('down', 0.5)} initial="hidden" whileInView={'show'} className='hidden pfp lg:flex flex-1 max-w-[320px] lg:max-w-[482px]'>
           <img src={Image}/>
          </motion.div>
      </div>
    </div>
  </section>
  );
};

export default Banner;
